import script from "./StdColumnMixin.vue?vue&type=script&lang=js"
export * from "./StdColumnMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__